import * as React from "react";
import ShadowGPT from "./ShadowGPT";

interface ShadowGPTFloatProps {
  className?: string;
  displayIn?: "page" | "dialog";
  data?: any;
}

const ShadowGPTFloat: React.FC<ShadowGPTFloatProps> = ({
  className = "",
  displayIn = "page",
  data,
}) => {
  const dragRef = React.useRef<HTMLDivElement>(null);
  const parentContainerRef = React.useRef<HTMLDivElement>(null);
  const [openChat, setOpenChat] = React.useState(false);
  const [isExpanded, setIsExpanded] = React.useState(false);

  // React.useEffect(() => {
  //   if (dragRef.current) {
  //     let parentItem: any = window.document.body;
  //     if (displayIn == "dialog") {
  //       parentItem = dragRef.current.closest('[data-state="open"]');
  //     }
  //     const viewportWidth = parentItem?.getBoundingClientRect()?.width || 0;
  //     const viewportHeight = parentItem?.getBoundingClientRect()?.bottom || 0;

  //     const dragElement = dragRef.current;
  //     const gptIconWidth =
  //       dragElement.querySelector(".gptIcon")?.getBoundingClientRect()
  //         .width || 0;
  //     const gptIconHeight =
  //       dragElement.querySelector(".gptIcon")?.getBoundingClientRect()
  //         .height || 0;

  //     const chatWidth =
  //       dragElement.querySelector(".chatArea")?.getBoundingClientRect()
  //         .width || 0;
  //     const chatHeight =
  //       dragElement.querySelector(".chatArea")?.getBoundingClientRect()
  //         .height || 0;

  //     const elementWidth = gptIconWidth + chatWidth;
  //     const elementHeight = Math.max(gptIconHeight, chatHeight);

  //     let newLeft = dragRef.current.offsetLeft;
  //     let newTop = dragRef.current.offsetTop;

  //     if (displayIn == "page") {
  //       if (newLeft < 0) newLeft = 0;
  //       if (newTop < 0) newTop = 0;
  //       if (newLeft + elementWidth > viewportWidth)
  //         newLeft = viewportWidth - elementWidth - 10;
  //       if (newTop + elementHeight > viewportHeight)
  //         newTop = viewportHeight - elementHeight - 10;

  //       // dragRef.current.style.left = newLeft + "px";
  //       // dragRef.current.style.top = newTop + "px";
  //     } else if (displayIn == "dialog") {
  //       console.log("dialog");
  //       const parent = dragRef.current.closest('[data-state="open"]');
  //       if (parent) {
  //         const parentBox = parent.getBoundingClientRect();
  //         // dragRef.current.style.left = parentBox.right - elementWidth - 10 + "px";
  //         // dragRef.current.style.bottom = 0 + "px";
  //         console.log(parentBox.bottom);
  //       }
  //     }
  //   }
  // }, [openChat]);

  let offsetX: number = 0,
    offsetY: number = 0;

  let initialX: number = 0,
    initialY: number = 0;

  function mouseDown(e: any) {
    if (!dragRef.current) return;
    offsetX = e.clientX - dragRef.current.getBoundingClientRect().left;
    offsetY = e.clientY - dragRef.current.getBoundingClientRect().top;
    if (displayIn == "dialog") {
      const parent = dragRef.current.parentElement;
      if (!parent) return;
      offsetX = offsetX + parent.getBoundingClientRect().left;
      offsetY =
        offsetY +
        Math.max(0, parent.getBoundingClientRect().top + parent.scrollTop);
    }
    initialX = e.clientX;
    initialY = e.clientY;

    document.addEventListener("mousemove", mouseMove);
    document.addEventListener("mouseup", mouseUp);
  }

  function mouseMove(e: any) {
    if (!dragRef.current) return;
    // Get the viewport dimensions
    let parentItem: any = window.document.body;
    if (displayIn == "dialog") {
      parentItem = dragRef.current.closest('[data-state="open"]');
    }
    dragRef.current.style.position = "fixed";

    const gptHeight =
      dragRef.current.querySelector(".gptIcon")?.getBoundingClientRect()
        .height || 0;
    const chatHeight =
      dragRef.current.querySelector(".chatArea")?.getBoundingClientRect()
        .height || 0;
    let elementHeight = gptHeight;
    if (openChat) {
      elementHeight = chatHeight;
    }

    const gptWidth =
      dragRef.current.querySelector(".gptIcon")?.getBoundingClientRect()
        .width || 0;
    const chatWidth =
      dragRef.current.querySelector(".chatArea")?.getBoundingClientRect()
        .width || 0;
    let elementWidth = gptWidth;
    if (openChat) {
      elementWidth = chatWidth + gptWidth;
    }

    const newRight = window.innerWidth - e.clientX - gptWidth / 2;
    const newBottom = window.innerHeight - e.clientY - gptHeight / 2;

    dragRef.current.style.right = newRight + "px";
    dragRef.current.style.bottom = newBottom + "px";

    //Restrict the movement of the chat icon
    const maxRight =
      window.innerWidth -
      parentItem?.getBoundingClientRect()?.left -
      elementWidth -
      20;
    const minRight =
      window.innerWidth - parentItem?.getBoundingClientRect()?.right + 20;
    const maxBottom =
      window.innerHeight -
      parentItem?.getBoundingClientRect()?.top -
      elementHeight -
      20;
    const minBottom =
      window.innerHeight - parentItem?.getBoundingClientRect()?.bottom;

    if (minRight > newRight) {
      dragRef.current.style.right = minRight + "px";
    }
    if (minBottom > newBottom) {
      dragRef.current.style.bottom = minBottom + "px";
    }

    if (newRight > maxRight) {
      dragRef.current.style.right = maxRight + "px";
    }
    if (newBottom > maxBottom) {
      dragRef.current.style.bottom = maxBottom + "px";
    }
  }

  function mouseUp(e: any) {
    document.removeEventListener("mousemove", mouseMove);
    document.removeEventListener("mouseup", mouseUp);

    const dx = e.clientX - initialX;
    const dy = e.clientY - initialY;
    if (Math.abs(dx) < 5 && Math.abs(dy) < 5) {
      setOpenChat(!openChat);
    }
  }

  const shadowGPTStatus = sessionStorage.getItem("shadowGPTStatus");
  if (!shadowGPTStatus || shadowGPTStatus != "on") {
    return <></>;
  }

  const GetPosition = () => {
    let position = {};
    if (displayIn == "dialog") {
      position = {
        position: "fixed",
        right: dragRef?.current?.parentElement?.getBoundingClientRect().left,
        bottom: dragRef?.current?.parentElement?.getBoundingClientRect().top,
      };
    } else {
      position = {
        right: "30px",
        bottom: "30px",
        position: "absolute",
      };
    }
    return position;
  };

  return (
    <>
      <div
        className={"z-level-3 " + className}
        style={GetPosition()}
        ref={dragRef}
      >
        <div className="relative mb-4 whitespace-nowrap overflow-x-visible">
          <div
            ref={parentContainerRef}
            style={{ position: "relative" }}
            className={
              "whitespace-nowrap chatArea overflow-y-hidden transition-all duration-200 overflow-x-hidden inline-block mr-4 " +
              (openChat
                ? isExpanded
                  ? "w-[60vw] h-[90vh]"
                  : "w-[25vw] h-[60vh]"
                : "w-0 h-0")
            }
          >
            <ShadowGPT
              data={data}
              className="w-full h-full border-none shadow-xl "
              setIsExpanded={setIsExpanded}
              isExpanded={isExpanded}
            />
          </div>
          <div
            className={
              "align-bottom gptIcon select-none mb-2 bg-primary-background inline-block cursor-move rounded-full shadow-xl"
            }
            onMouseDown={(e: any) => mouseDown(e)}
          >
            <img
              src={process.env.STATIC_PATH + "/img/shadowGPT/Circle.gif"}
              className="w-[80px] h-[80px] rounded-full pointer-events-none hue-rotate-[135deg] saturate-[1.2] brightness-[0.70] contrast-[1.15]"
              alt=""
            />
          </div>
        </div>
      </div>
    </>
  );
};

export default ShadowGPTFloat;
